import styled from 'styled-components';

import { LayoutColors } from '@src/core/theme';
import { BodyRegular, BodyRegularBold } from '@src/fonts/typography/Typography';
import { AlertProps } from '.';

const colorsMap = {
  info: {
    ghost: { background: LayoutColors.justBlueLigth, color: LayoutColors.justBlue, borderColor: 'unset' },
    outlined: { background: 'unset', color: LayoutColors.justBlue, borderColor: LayoutColors.justBlue },
  },
  success: {
    ghost: { background: LayoutColors.successLight, color: LayoutColors.successMain, borderColor: 'unset' },
    outlined: { background: 'unset', color: LayoutColors.successMain, borderColor: LayoutColors.successMain },
  },
  warning: {
    ghost: { background: LayoutColors.warningLight, color: LayoutColors.warningMain, borderColor: 'unset' },
    outlined: { background: 'unset', color: LayoutColors.warningMain, borderColor: LayoutColors.warningMain },
  },
  error: {
    ghost: { background: LayoutColors.errorLight, color: LayoutColors.errorMain, borderColor: 'unset' },
    outlined: { background: 'unset', color: LayoutColors.errorMain, borderColor: LayoutColors.errorMain },
  },
};

export const AlertContainer = styled.div<Pick<AlertProps, 'severity' | 'variant'>>`
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border-radius: 4px;
  background: ${({ severity = 'info', variant = 'ghost' }) => colorsMap[severity][variant].background};
  color: ${({ severity = 'info', variant = 'ghost' }) => colorsMap[severity][variant].color};

  border: ${({ variant, severity = 'info' }) => {
    if (variant === 'outlined') {
      return `1px solid ${colorsMap[severity][variant].borderColor}`;
    }

    return 'unset';
  }};
`;

export const IconSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 16px;
  color: inherit;
`;

export const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  ${BodyRegular};
  color: inherit;
`;

export const AlertTitle = styled.h3`
  ${BodyRegularBold}
  line-height: normal;

  color: inherit;
`;
